import { httpRequest } from "../../../utils/HttpRequest";
import { IKey, IPage, ISearchPage } from "../../../types/ScmTypes";
export interface IDetailList {
    id?:string,                        // "9a342169290648569c696033a169f0d7",
    stockInId?:string,                        // "bdde3beb0699495ab1c975e05727b27a",
    tradeCode?:string,                        // "CG20210127034",
    materialCode?:string,                        // "WL--018",
    materialName?:string,                        // "扳手37",
    replaceCode?:string,                        // "WL--0987678",
    price?:string,                        // 100,
    num?:string,                        // 10,
    discountRate?:string,                        // 0,
    amount?:string,                        // 1000,
    warehouseCode?:string,                        // "sa001",
    warehouseName?:string,                        // "沙特库",
    shelfId?:string,                        // "1350099357982035970",
    shelfCode?:string,                        // "c1",
    createUser?:string,                        // "张帅"
}
export interface Ids {
    id: string
}
export interface Detailed {
    detailed: Ids[]
}
export interface IStockOutputFields {
    inTotal?: number,  //10,
    billingTime?: string,  //"2021-01-27",
    tradeCode?: string,  //"CG20210127034",
    billingClerk?: string,  //"张帅",
    tradeTypeName?: string,  //"采购单",
    ioFlag?: number,  //1,
    id?: string,  //"bdde3beb0699495ab1c975e05727b27a",
    stockIoTime?: string,  //"2021-01-28",
    tradeTypeCode?: string,  //"purchase"
}
export interface ITotalVo {
    InTotal: number,
    totalNum: number
}
export interface IStock{
    hitCount: boolean,
    optimizeCountSql: boolean,
    records:IStockOutputFields[],
    size: number,
    total: number,
    current:number,
    [key:string]:any,

}
export type IStockOutputSearch = IStockOutputFields & ISearchPage;
export type IStockOutputDetail = {
    totalVo:ITotalVo,
    stock:IStock
}
export interface IStockOutputDetailID extends IStockOutputFields{
    details:IDetailList[]
}
class StockOutputService {
    async page(searchVo: IStockOutputSearch) {
        const apiUrl = "/vrm-sa/stock/out/findPage";
        return await httpRequest.post<IStockOutputDetail[]>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/vrm-sa/stock/findById/${id}`;
        return await httpRequest.get<IStockOutputDetailID>(apiUrl);
    }
}

export const stockOutputService = new StockOutputService();